// import { useEffect, useRef } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'react-toastify/dist/ReactToastify.css';
// import "../src/Css/custom.css";
// import Routing from './Routes/Routing';
// import { logoutApi } from './Data/data';

// function App() {
//   // Use ref to keep track if it is a refresh
//   const isReload = useRef(false);

//   useEffect(() => {
//     // This runs when page visibility changes (tab hidden)
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === "hidden") {
//         // Page is hidden: user might be refreshing or closing tab
//         // Set flag to true, assuming a reload could happen soon
//         isReload.current = true;
//       }
//     };

//     // This runs when user tries to unload the page (close or refresh)
//     const handleLogout = (event) => {
//       const msisdn = sessionStorage.getItem("ani");
//       const skipLogout = sessionStorage.getItem("skipLogout");

//       if (msisdn && skipLogout !== "true") {
//         // If isReload flag is true, it's probably a refresh => skip logout API
//         if (isReload.current) {
//           // Reset the flag for next time and skip logout
//           isReload.current = false;
//           return;
//         }

//         // Otherwise, consider it a tab/window close and call logout API
//         const payload = new URLSearchParams({ msisdn }).toString();


import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "../src/Css/custom.css";
import Routing from './Routes/Routing';
import { logoutApi } from './Data/data';

function App() {
  useEffect(() => {
    // Check if current path includes /subscription or /login
    const path = window.location.pathname;
    const isTargetPage = path.includes("/subscription") || path.includes("/login");
    if (!isTargetPage) return;

    const logout = () => {
      const msisdn = sessionStorage.getItem("ani");
      const skipLogout = sessionStorage.getItem("skipLogout");

      if (msisdn && skipLogout !== "true") {
        const url = `${logoutApi}?msisdn=${msisdn}`;
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url);
        } else {
          const xhr = new XMLHttpRequest();
          xhr.open("POST", url, false);
          xhr.send(null);
        }
      }
      sessionStorage.removeItem("skipLogout");
    };

    // Detect new tab only on these pages
    if (!sessionStorage.getItem("tabOpened")) {
      sessionStorage.setItem("tabOpened", "true");
      // Optionally call API for new tab opened here
    }

    window.addEventListener("pagehide", logout);
    window.addEventListener("beforeunload", logout);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        logout();
      }
    });

    return () => {
      window.removeEventListener("pagehide", logout);
      window.removeEventListener("beforeunload", logout);
      document.removeEventListener("visibilitychange", logout);
    };
  }, []);

  return <Routing />;
}

export default App;
